define.alias("ember-tooltips/components/ember-popover", "settings/components/ember-popover");